import { Component, OnInit } from "@angular/core";

import { OrganizationService } from "../../../services/organization.service";
import { OrganizationEventType, OrganizationEvent } from "../../../models/organization.model";
import { SidePanelBase } from "../../side-panel-base.class";

@Component({
    selector: 'organization-history',
    templateUrl: './organization-history.component.html',
    styleUrls: ['./organization-history.component.scss'],
    standalone: false
})
export class OrganizationHistoryComponent extends SidePanelBase implements OnInit {


	static componentName = 'OrganizationHistoryComponent';

	get organization() {
		return this.componentData.data;
	}

	constructor(public service: OrganizationService) { super(); }

	ngOnInit() {

	}

	getEventDescription(event: OrganizationEvent): string {
		let value = "";
		let type: OrganizationEventType = event.eventType;
		switch(type) {
			case OrganizationEventType.OrganizationCreated: {
				value =  'Organization Created';
				break;
			}
			case OrganizationEventType.ApplicationSubmitted: {
				value = 'Application Submitted';
				break;
			}
			case OrganizationEventType.AccountApproved: {
				value = 'Account Approved';
				break;
			}
			case OrganizationEventType.OutOfCompliance: {
				value = 'Out Of Compliance';
				break;
			}
			case OrganizationEventType.OrganizationCancelled: {
				value = 'Organization Cancelled Ownership';
				break;
			}
			case OrganizationEventType.NameChanged: {
				value = 'Organization Changed Its Name';
				break;
			}
			case OrganizationEventType.EnforcementExhausted: {
				value = 'Enforcement Exhausted';
				break;
			}			
		};
		return value;
	  }

	getEventClass(type: OrganizationEventType): string {
		let value: string = ""
		switch (type) {
			case OrganizationEventType.AccountApproved:
			case OrganizationEventType.OrganizationCreated: {
				value = 'green';
				break;
			}
			case OrganizationEventType.ApplicationSubmitted:
			case OrganizationEventType.NameChanged: {
				value = 'blue';
				break;
			}
			case OrganizationEventType.EnforcementExhausted:
			case OrganizationEventType.OrganizationCancelled:
			case OrganizationEventType.OutOfCompliance: {
				value = 'redBackground';
				break;
			}
		}
		return value;
	}	

	getOrganizationName(id: string): string {
		let name: string = this.service.getOrganizationName(id);
		if (name == null || name.length == 0) {
			name = id;
		}
		return name;
	}

}
